// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const GetSubscriptionCalloutLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-getsubscriptioncallout" */ "./GetSubscriptionCallout")).then((bundle)=>{
        return {
            default: bundle.GetSubscriptionCallout
        };
    });
export const LazyGetSubscriptionCallout = /*#__PURE__*/ lazy(GetSubscriptionCalloutLazyLoader);
